export enum NonAccrualStatusIndicator {
	UNSET = 'UNSET',
	STATUS_CODE = 'STATUS_CODE',
	PRODUCT_CODE = 'PRODUCT_CODE',
	STATUS_CODE_OR_PRODUCT_CODE = 'STATUS_CODE_OR_PRODUCT_CODE',
	STATUS_CODE_AND_PRODUCT_CODE = 'STATUS_CODE_AND_PRODUCT_CODE',
	NON_ACCRUAL_DATE = 'NON_ACCRUAL_DATE',
	STATUS_CODE_OR_NON_ACCRUAL_DATE = 'STATUS_CODE_OR_NON_ACCRUAL_DATE',
	STATUS_CODE_AND_NON_ACCRUAL_DATE = 'STATUS_CODE_AND_NON_ACCRUAL_DATE',
	PRODUCT_CODE_OR_NON_ACCRUAL_DATE = 'PRODUCT_CODE_OR_NON_ACCRUAL_DATE',
	PRODUCT_CODE_AND_NON_ACCRUAL_DATE = 'PRODUCT_CODE_AND_NON_ACCRUAL_DATE',
	STATUS_CODE_OR_PRODUCT_CODE_OR_NON_ACCRUAL_DATE = 'STATUS_CODE_OR_PRODUCT_CODE_OR_NON_ACCRUAL_DATE',
	STATUS_CODE_AND_PRODUCT_CODE_AND_NON_ACCRUAL_DATE = 'STATUS_CODE_AND_PRODUCT_CODE_AND_NON_ACCRUAL_DATE',
}

export default NonAccrualStatusIndicator;
